/**
 * スタミナ制の定数とデータ型定義。
 *
 * ハードコード禁止ルールに従い、スタミナ関連の数値・キーをすべてこのファイルに集約する。
 * 他モジュール（`services/stamina.ts` / `hooks/useStamina.ts` / UI）からはここの
 * 定数のみを参照すること。
 *
 * 参考ルール:
 *   - `.claude/rules/no-hardcode.md`
 *   - `.claude/rules/conventions.md`（日付は UTC ベース）
 */

/** ベースの最大スタミナ（デイリーボーナス未取得時の上限）。 */
export const STAMINA_MAX_BASE = 5

/** スタミナ 1 回復にかかる時間（ミリ秒）。30 分に設定。 */
export const STAMINA_RECOVERY_INTERVAL_MS = 30 * 60 * 1000

/**
 * デイリーボーナスで加算されるスタミナ量。
 * これを受け取ると最大値も一時的に +5 され、かつ現在値も +5 される。
 */
export const STAMINA_DAILY_BONUS = 5

/** スタミナ本体の永続化キー。 */
export const STAMINA_STORAGE_KEY = 'luckyanimal_nawabari_stamina_v1'

/** デイリーボーナスの受け取り状況の永続化キー。 */
export const STAMINA_DAILY_BONUS_STORAGE_KEY =
  'luckyanimal_nawabari_stamina_daily_bonus_v1'

/**
 * スタミナの絶対上限。オーバーフローやバグによる異常値を防ぐためのセーフティ値。
 * ベース + デイリーボーナスを超えることは通常ありえない。
 */
export const MAX_STAMINA_ABSOLUTE = STAMINA_MAX_BASE + STAMINA_DAILY_BONUS

/**
 * 永続化される現在スタミナの状態。
 *
 * `maxStamina` はデイリーボーナス受け取り状況によって `STAMINA_MAX_BASE` or
 * `STAMINA_MAX_BASE + STAMINA_DAILY_BONUS` のいずれかになる（計算時に決まる）。
 */
export interface StaminaState {
  amount: number
  /** 最後に「スタミナ残量が変化した時刻」。自然回復の計算基準として使う。 */
  lastUpdateTime: number
  /** その時点での最大スタミナ（ボーナス込み）。UI 表示用に保存する。 */
  maxStamina: number
}

/**
 * デイリーボーナスの受け取り履歴。
 *
 * `lastClaimedDate` は UTC ベースの `YYYY-MM-DD` 形式（`conventions.md` 準拠）。
 * 空文字列は「一度も受け取っていない」状態を表す。
 */
export interface DailyBonusState {
  lastClaimedDate: string
}
